import { motion } from "framer-motion";
import { Quote, Building2, Coffee, Hotel, Pizza, ShoppingBag, Truck } from "lucide-react";
import { SectionHeader } from "@/components/sections/SectionHeader";

const TESTIMONIALS = [
  {
    quote: "Am ales DOTAPAN pentru că produsele sunt constante și ușor de integrat în fluxul nostru zilnic.",
    author: "Manager bucătărie",
    business: "Restaurant • Cluj",
  },
  {
    quote: "Croissantele se coc frumos, arată bine în vitrină și se vând repede. Clienții revin după ele.",
    author: "Proprietar",
    business: "Cafenea • Bistrița",
  },
  {
    quote: "Blatul de pizza ne-a ajutat să păstrăm gustul bun și să lucrăm mai rapid în zilele aglomerate.",
    author: "Chef",
    business: "Pizzerie • Sibiu",
  },
];

const PARTNERS = [
  { icon: Building2, label: "Restaurante" },
  { icon: Coffee, label: "Cafenele" },
  { icon: Hotel, label: "Hoteluri" },
  { icon: Pizza, label: "Pizzerii" },
  { icon: ShoppingBag, label: "Magazine" },
  { icon: Truck, label: "Distribuitori" },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="section-pad bg-bg">
      <div className="max-w-7xl mx-auto container-px">
        <SectionHeader
          eyebrow="Testimoniale și parteneri"
          title="Afaceri care aleg constanța."
          align="center"
          testId="testimonials-header"
        />

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-soft p-7"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="h-7 w-7 text-gold" />
              <p className="mt-4 font-display italic text-lg md:text-xl text-text leading-snug">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-6 pt-5 border-t border-border">
                <div className="font-medium text-text">{t.author}</div>
                <div className="text-xs uppercase tracking-[0.2em] text-text-soft mt-1">{t.business}</div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 pt-12 border-t border-border">
          <p className="eyebrow text-center mb-8">Lucrăm cu</p>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-3">
            {PARTNERS.map((p, i) => (
              <motion.div
                key={p.label}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="flex flex-col items-center gap-2 p-5 rounded-2xl border border-border hover:border-gold transition-colors"
              >
                <p.icon className="h-6 w-6 text-gold" />
                <span className="text-xs uppercase tracking-[0.2em] text-text-soft">{p.label}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
